import { integrationsActionsMenu, integrationsCard, integrationsRulename } from './card';
import { integrationsOverview } from './overview';

let overviewSteps = [integrationsOverview, integrationsCard, integrationsActionsMenu, integrationsRulename];

export const OVERVIEW_STEPS = overviewSteps;
